import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("greetly_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  // Forward the LockGate unlock passcode on every request so the server-
  // side app_lock_wall middleware lets us through. Without this, every
  // API call from the app returns 503 even after the user has unlocked.
  const unlockKey = localStorage.getItem("buzzerai_unlock_key");
  if (unlockKey) cfg.headers["X-App-Unlock"] = unlockKey;
  return cfg;
});

export const setToken = (t) => localStorage.setItem("greetly_token", t);
export const clearToken = () => localStorage.removeItem("greetly_token");
export const getToken = () => localStorage.getItem("greetly_token");

// ---------- Super-admin impersonation ----------
// When the founder clicks "View as X" in /admin/customers we stash the admin's
// original token under a separate key, then swap the active token for the
// target business's token. The dashboard shell reads `getAdminReturnToken()`
// to render a "Return to admin" banner. `stopImpersonation()` restores the
// original token.
const ADMIN_RETURN_KEY = "greetly_admin_return_token";
export const startImpersonation = (newToken) => {
  const current = getToken();
  if (current) localStorage.setItem(ADMIN_RETURN_KEY, current);
  setToken(newToken);
};
export const stopImpersonation = () => {
  const stashed = localStorage.getItem(ADMIN_RETURN_KEY);
  if (stashed) {
    setToken(stashed);
    localStorage.removeItem(ADMIN_RETURN_KEY);
  } else {
    clearToken();
  }
};
export const getAdminReturnToken = () => localStorage.getItem(ADMIN_RETURN_KEY);
export const isImpersonating = () => !!localStorage.getItem(ADMIN_RETURN_KEY);
